
class CapScheduleRequestControlPanelErrors {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_schedule_request_control_panel_errors'
}

function create(config) {
  return new CapScheduleRequestControlPanelErrors(config)
}

export default {
  key,
  create,
}
